export default __webpack_public_path__ + "static/media/innovation.d973b04e.png";